export default __webpack_public_path__ + "static/light-one-eba8807b8fa04209d4fda8265812e5f7.png";